import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getUserData } from '@/libs/cookie'

Vue.use(VueI18n)
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}
const user_data = getUserData()
const lang = (user_data && user_data.language) ? user_data.language : 'en'
export default new VueI18n({
  locale: lang,
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
})
